import styled, { css } from 'styled-components';

export const Container = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.layout.spacing(1.5)};
    border: none;
    background: none;
    cursor: pointer;

    svg {
      font-size: 1.25rem;
      color: ${theme.palette.primary.main};
      transition: all 0.2s;
    }

    &:hover svg {
      color: ${theme.palette.primary.light};
    }

    span {
      color: ${theme.palette.text.main};
      font-family: ${theme.typography.family};
      font-size: ${theme.typography.sizes.body1};
      font-weight: ${theme.typography.weight.light};
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    &:disabled svg {
      color: ${theme.palette.neutral[300]};
    }

    &:disabled span {
      color: ${theme.palette.neutral[300]};
    }

    &:disabled:hover svg {
      color: ${theme.palette.neutral[300]};
    }
  `}
`;
